
export default {
  data() {
    return {
      benefits: [
        {
          title: "دسترسی به پنل اوپن استک شخصی‌سازی شده توسط آبالون",
          img: "openstack.svg",
          desc: "پنل کاربری دیتاسنتر ابری، یک رابط کاربری گرافیکی مبتنی بر وب را برای مدیریت VMها در یک فضای یکپارچه فراهم می‌کند. در این پنل می‌توانید مدیریت تمامی جزئیات VMها، والیوم‌ها، اسنپ‌شات‌ها، SDN، لود بالانسینگ، رول‌های فایروال و … را، خود به عهده بگیرید.",
          img_alt: "دیتاسنتر ابری مبتنی بر پنل اوپن استک اختصاصی",
          img_title: "وی پی سی مبتنی بر پنل اوپن استک اختصاصی",
        },
        {
          title: "پیاده‌سازی لود بالانسینگ",
          img: "blancing.svg",
          desc: "توزیع بار در زیرساخت‌های ابری از ویژگی‌های حیاتی است. دیتاسنتر ابری آبالون امکان توزیع بار کاری را فراهم می‌کند تا اطمینان داشته باشید سرویس‌های شما همیشه در دسترس کاربران باقی می‌ماند.",
          img_alt: "اجرای لود بالانسینگ در وی پی سی",
          img_title: "اجرای لود بالانسینگ در وی پی سی",
        },
        {
          title: "بارگذاری ایمیج دلخواه سیستم‌عامل یا والیوم",
          img: "image.svg",
          desc: "در پنل وی پی سی می‌‌توانید ایمیج‌های آماده آبالون را برای نصب سیستم‌عامل انتخاب کنید یا ایمیج سیستم‌عامل یا والیوم دلخواه خود را بارگذاری نمایید و از روی آنها VM دلخواه خود را بسازید.",
          img_alt: "بارگذاری ایمیج سیستم‌عامل یا والیوم در وی پی سی",
          img_title: "بارگذاری ایمیج سیستم‌عامل یا والیوم در وی پی سی",
        },
        {
          title: "پشتیبان‌گیری خودکار",
          img: "backup.svg",
          desc: "قابلیت DRaaS‌ در دیتاسنتر ابری امکان پشتیبان‌گیری خودکار از VMها را فراهم می‌کند تا در صورت وقوع هر مشکل یا سانحه، به سرعت بتوانید به نسخه بکاپ دلخواه خود باز گردید.",
          img_alt: "اجرای پشتیبان‌گیری خودکار با خرید VPC",
          img_title: "اجرای پشتیبان‌گیری خودکار با خرید VPC",
        },
        {
          title: "اسنپ‌شات",
          img: "snapshot.svg",
          desc: "با استفاده از اسنپ‌شات می‌توانید از هر VM خود یک ایمیج تهیه کنید و به سادگی یک VM مشابه دیگر را روی دیتاسنتر ابری آبالون یا هر زیرساخت ابری دیگر بازنشانی نمایید.",
          img_alt: "ایجاد اسنپ‌شات در وی پی سی",
          img_title: "ایجاد اسنپ‌شات در ,وی پی سی",
        },
        {
          title: "مدیریت SDN",
          img: "sdn.svg",
          desc: "با SDN، بدون به‌کار گرفتن تجهیزات فیزیکی اضافی، شبکه‌های پیچیده را ایجاد و مدیریت کرده و رول‌های فایروال دلخواه خود را در گروه‌های متعدد ایجاد نمایید. کافی‌ست هر تعداد گروه شامل صدها رول را به VMهای دلخواه مرتبط کنید تا به سرعت بر آنها اعمال شود.",
          img_alt: "مدیریت SDN در دیتاسنتر ابری",
          img_title: "مدیریت SDN در دیتاسنتر ابری",
        },
        {
          title: "منابع نامحدود",
          img: "improve.svg",
          desc: "در پنل دیتاسنتر ابری، می‌توانید VMهای متنوع را بسازید و به هر کدام، منابع دلخواه را تخصیص دهید. همچنین در هر لحظه حین استفاده از سرویس امکان کاهش یا افزایش سریع منابع هر VM یا کل وی پی سی برای‌تان فراهم است.",
          img_alt: "منابع نامحدود با خرید وی پی سی",
          img_title: "منابع نامحدود با خرید وی پی سی",
        },
      ],
    };
  },
  methods: {},
};
